import React, { useState, useEffect } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { circularProgressClasses } from "@mui/material";
const CircularLoader = (props) => {
  const {
    variant = "determinate",
    value,
    isProgress = true,
    color1 = "#e0e0e0",
    color2 = "#434DF9",
  } = props;
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prev) => {
        if (prev >= value) {
          return value;
        } else {
          return prev + 1;
        }
      });
    }, 1);
    return () => {
      clearInterval(timer);
    };
  }, [value]);
  return (
    <Box sx={{ position: "relative" }}>
      <CircularProgress
        sx={{
          color: color1,
          // color: "rgb(222, 216, 254)",
        }}
        size={60}
        thickness={4}
        variant={variant || "determinate"}
        value={100}
      />
      <CircularProgress
        variant={variant}
        sx={{
          color: color2,
          animationDuration: "550ms",
          position: "absolute",
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round",
          },
        }}
        size={60}
        thickness={4}
        value={progress}
      />
      {isProgress && (
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            margin: "8px 8px 12px 8px",
            paddingLeft: "3px",
          }}
        >
          <Typography
            variant="caption"
            component="div"
            color="#000"
            sx={{ fontSize: "15px", fontWeight: 700 }}
          >
            {`${Math.round(progress)}%`}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default CircularLoader;
